<template>
  <div class="share-code-page">
    <img
      class="share-code-bg"
      src="@/assets/img/chargingVoucher/bg-share-code.png"
    >
    <div class="share-code-content">
      <div class="share-code-content-title">如何分享拉新码</div>
      <div class="share-code-content-info">
        您可以点击此页底部【生成分享码】生成专有分享码海报并进行转发。
      </div>
      <div class="share-code-content-title">如何定义拉新</div>
      <div class="share-code-content-info">
        虾米车服平台新用户扫描您的分享码后，将成为您的直接拉新人。您的直接拉新人通过他的分享码发展新用户，则该新用户将成为您的间接拉新人。
      </div>
      <div class="share-code-content-title">如何返利</div>
      <div class="share-code-content-info">
        您的直接拉新人在虾米车服充电服务中购买充电券，您将获得订单金额0.7%的返利；您的间接拉新人购买充电券，您将获得订单金额0.3%的返利。
      </div>
      <div class="share-code-content-title">其他</div>
      <div class="share-code-content-info">
        本活动的拉新权益只涵盖直接拉新人和间接拉新人，不穿透到第三层及以上转发。<br>
        拉新及收益的活动规则解释权归虾米车服所有
      </div>
    </div>

    <div class="h-120" />
    <div class="share-code-page-btns h-120">
      <div
        class="share-code-page-btn btn-primary"
        @click="toShareCodePost"
      >
        生成分享码
      </div>
    </div>

    <!-- 规则弹窗 -->
    <RulePopup ref="refRulePopup" />
  </div>
</template>

<script>
import RulePopup from './components/RulePopup.vue';
import tokenMixin from './mixins/tokenMixin.js';

export default {
  name: 'ShareCode',
  components: {
    RulePopup
  },
  data() {
    return {
      authorize: '0'
    };
  },
  mixins: [tokenMixin],
  methods: {
    init() {
      const query = this.$route.query;
      // 处理从小程序入口跳转过来
      if (Object.keys(query).length) {
        // 基础信息
        const phone = this.$route.query.phone || '';
        if (phone) localStorage.setItem('_phone', phone);

        this.$router.replace({
          name: 'ChargingVoucherShareCode'
        });
      }
    },
    toShareCodePost() {
      this.$router.push({
        name: 'ChargingVoucherShareCodePost'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.share-code-page {
  background: #fff2f1;
  box-sizing: border-box;
  min-height: calc(100vh - constant(safe-area-inset-bottom));
  min-height: calc(100vh - env(safe-area-inset-bottom));

  .share-code-bg {
    width: 100vw;
    height: 520px;
  }
  .share-code-content {
    margin: 0px 24px 24px 24px;
    background: #ffffff;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 48px 40px;
    transform: translateY(-88px);

    .share-code-content-title {
      font-size: 32px;
      color: #000000;
      letter-spacing: -1.48px;
      font-weight: bold;
      line-height: 45px;
      margin-bottom: 17px;
      display: flex;
      align-items: center;

      &::before {
        content: "";
        display: inline-block;
        width: 36px;
        height: 30px;
        background: url("~@/assets/img/chargingVoucher/icon-title.png");
        background-size: contain;
        background-repeat: no-repeat;
        margin-right: 6px;
      }
    }
    .share-code-content-info {
      font-size: 30px;
      color: #646464;
      letter-spacing: -1.39px;
      font-weight: 400;
      line-height: 42px;
      margin-bottom: 48px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .share-code-page-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px rgba(230, 230, 230, 1);
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 15px 32px;
    padding-bottom: calc(15px + constant(safe-area-inset-bottom));
    padding-bottom: calc(15px + env(safe-area-inset-bottom));
    height: calc(120px + constant(safe-area-inset-bottom));
    height: calc(120px + env(safe-area-inset-bottom));
    width: 100vw;

    .share-code-page-btn {
      height: 90px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;

      &.btn-default {
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 32px;
        color: #383838;
        font-weight: 400;
      }
      &.btn-primary {
        background: #fe6456;
        font-size: 32px;
        color: #ffffff;
        font-weight: 400;
      }
    }
  }
}
.h-120 {
  height: calc(120px + constant(safe-area-inset-bottom));
  height: calc(120px + env(safe-area-inset-bottom));
}
</style>
